import { render, staticRenderFns } from "./ModalPesquisarModelo.vue?vue&type=template&id=6c8d2ca1"
import script from "./ModalPesquisarModelo.vue?vue&type=script&lang=ts"
export * from "./ModalPesquisarModelo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports